// src/App.js
import React, { useEffect } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import RequireAuth from "./components/RequireAuth";
import RedirectIfAuthenticated from "./components/RedirectIfAuthenticated";

import Login from "./pages/Login";
import AdminLayout from "./layouts/AdminLayout";
import Dashboard from "./pages/dashboard/Dashboard";

import Passengers from "./pages/users/Passengers";
import Drivers from "./pages/users/operators/Drivers";
import Operators from "./pages/users/operators/Operators";
import Jeepney from "./pages/users/operators/Jeepney";

import Bookings from "./pages/bookings/Bookings";

import PaymentsCommission from "./pages/PaymentsCommission";
import PaymentsHistory from "./pages/PaymentsHistory";
import Payouts from "./pages/payments/Payouts";
import Wallet from "./pages/wallet/Wallet";

import LocationTracking from "./pages/tracking/LocationTracking";
import Audit from "./pages/audit/AuditLogs";
import ViewRatings from "./pages/feedback/ViewRatings";
import Settings from "./pages/settings/Settings";

import "./App.css";

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    const blockRefresh = (e) => {
      if (e.key === "F5" || (e.ctrlKey && e.key.toLowerCase() === "r")) {
        e.preventDefault();
      }
    };
    const blockContextMenu = (e) => e.preventDefault();

    document.addEventListener("keydown", blockRefresh);
    document.addEventListener("contextmenu", blockContextMenu);

    return () => {
      document.removeEventListener("keydown", blockRefresh);
      document.removeEventListener("contextmenu", blockContextMenu);
    };
  }, []);

  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        <Route
          path="/login"
          element={
            <RedirectIfAuthenticated>
              <Login />
            </RedirectIfAuthenticated>
          }
        />

        <Route
          element={
            <RequireAuth>
              <AdminLayout>
                <Outlet />
              </AdminLayout>
            </RequireAuth>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/passengers" element={<Passengers />} />
          <Route path="/operators/operators" element={<Operators />} />
          <Route path="/operators/jeepney" element={<Jeepney />} />
          <Route path="/operators/drivers" element={<Drivers />} />

          <Route path="/bookings" element={<Bookings />} />

          <Route path="/wallet/wallet" element={<Wallet />} />
          <Route path="/payments/payouts" element={<Payouts />} />
          <Route path="/payments-commission" element={<PaymentsCommission />} />
          <Route path="/payments-history" element={<PaymentsHistory />} />

          <Route path="/location" element={<LocationTracking />} />
          <Route path="/audit/audit-logs" element={<Audit />} />
          <Route path="/ratings" element={<ViewRatings />} />
          <Route path="/settings/settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;